export default __webpack_public_path__ + "static/media/bg-ring-2b.86b998b6.png";